import type { Product } from '../features/catalog/api'

/**
 * Полка «Популярное» приходит с сервера уже отобранной и непустой: если руками
 * ничего не отмечено, он добирает её лидерами продаж (В-28). Наше дело —
 * обрезать её до того, что помещается на главной.
 */
export function shelf(products: Product[], limit: number): Product[] {
  return products.slice(0, limit)
}
